<template>
    <FormSection>
        <template v-slot:title>
            {{ $t('messages.general_information') }}
        </template>
        <template v-slot:content>
            <form action="" @submit.prevent="submit">
                <div class="px-4 py-5 sm:p-6">
                    <div class="md:grid md:grid-cols-6 md:gap-6">
                        <div class="sm:col-span-3">
                            <label for="preferred_language" class="block text-sm font-medium leading-5 text-gray-700">
                                {{ $tc('messages.languages', 1) }}
                            </label>
                            <div class="mt-1 rounded-md shadow-sm">
                                <select
                                    id="preferred_language"
                                    v-model="form.preferred_language"
                                    name="preferred_language"
                                    ref="preferred_language"
                                    class="w-full mt-1 block py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                    <option value="" disabled>
                                        {{ $t('messages.select') }}
                                    </option>
                                    <option v-for="language in languages" :value="language">
                                        {{ $t(`locales.${language}`) }}
                                    </option>
                                </select>
                            </div>
                            <p class="mt-2 text-sm text-red-600" v-if="form.errors.preferred_language">
                                {{ form.errors.preferred_language }}
                            </p>
                        </div>

                        <div class="sm:col-span-3">
                            <div class="mt-1">
                                <label for="date_of_birth" class="block text-sm font-medium leading-5 text-gray-700">
                                    {{ $t('messages.date_of_birth') }}
                                </label>
                                <div class="mt-1 rounded-md shadow-sm">
                                    <input
                                        id="date_of_birth"
                                        name="date_of_birth"
                                        v-model="form.date_of_birth"
                                        type="date"
                                        ref="date_of_birth"
                                        class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                    />
                                </div>
                                <p class="mt-2 text-sm text-red-600" v-if="form.errors.date_of_birth">
                                    {{ form.errors.date_of_birth }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow sm:rounded-bl-md sm:rounded-br-md"
                >
                    <div class="mt-1">
                        <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                    </div>
                </div>
            </form>
        </template>
    </FormSection>
</template>

<script>
import FormSection from '@/components/FormSection.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    name: 'UpdateProfileInformationForm',
    components: {
        SubmitFormButton,
        FormSection,
    },
    props: ['languages', 'user'],
    data() {
        return {
            form: this.$inertia.form({
                preferred_language: this.user.preferred_language,
                date_of_birth: this.user.date_of_birth,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.route('user_settings.update'), {
                // errorBag: 'updatePassword',
                preserveScroll: true,
                onSuccess: () => {
                    this.$i18n.locale = this.user.preferred_language;
                },
                onError: () => {
                    if (this.form.errors.preferred_language) {
                        this.$refs.preferred_language.focus();
                    }
                    if (this.form.errors.date_of_birth) {
                        this.$refs.date_of_birth.focus();
                    }
                },
            });
        },
    },
};
</script>
